export default __webpack_public_path__ + "static/media/avatar.5a90d900.png";